import React from 'react';
import { Link } from 'react-router-dom'

class AboutUs extends React.PureComponent {
  render() {
    return (
      <section className="about-us">
        <h4 className="title">
          <Link to="/Introduction/CompanyProfile">了解我们</Link>
        </h4>
        <div>
          <p>国内领先的工程项目管理科技服务提供商，致力于“用科学技术为工程项目管理赋能”，让世界感受工程之美。</p>
          <img src={require('img/wx.png')} srcSet={`${require("img/wx.png")} 1x,${require("img/wx@2x.png")} 2x,${require("img/wx@3x.png")} 3x`} alt=""/>
          <span>官方微信</span>
          <a href='tel:400-607-8818'>联系我们：400-607-8818</a>
        </div>
      </section>
    );
  }
}

export default AboutUs;
